import React from 'react'
import * as S from './styles'

import ImageNext from '@/components/ImageNext'

const iconSize = 26

const DetailsIcon = ({ data }) => {
  return (
    data && (
      <S.DetailsIconContainer color={data.iconColor}>
        <ImageNext src={data.icon} width={iconSize} height={iconSize} />
      </S.DetailsIconContainer>
    )
  )
}

export default DetailsIcon
